export default "__VITE_ASSET__Byvapfjz__"